import React, { useEffect, useRef, useState } from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import Spinner from '../spinner/spinner';
import { CUSTOM_EVENTS, DEFAULT_LAT_LNG, GOOGLE_CONFIG } from '../../utils/constants';
import PropTypes from 'prop-types';
import GoogleWrapper from '../google-wrapper/google-wrapper.component';

const MyMapComponent = ({ center = DEFAULT_LAT_LNG, zoom = 13, title = 'Bhubaneswar' })  => {
    const ref = useRef();
    const mapRef = useRef(null);
    const markerRef = useRef(null);

    // NOTE: Map is made only for single marker with single map in a single page as of now. Can be modified later as per requirements
    useEffect(() => {
        // let markerListener = null;
        const removeMarker = () => {
            if (markerRef.current) {
                markerRef.current.setMap(null); // Remove the marker from the map
                markerRef.current = null; // Optionally set the marker reference to null
            }
        };
        const createMarker = async () => {
            removeMarker();
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            markerRef.current = new AdvancedMarkerElement({
                map: mapRef.current,
                position: center,
                title,
            });
            // mapRef.current.setCenter(center);
            mapRef.current.panTo(center);
        };
        const initMap = async (divRef) => {
            if (!mapRef.current) {
                const { Map } = await window.google.maps.importLibrary('maps');
                mapRef.current = new Map(divRef, {
                    center,
                    zoom,
                    // mapId: 'DEMO_MAP_ID', // It should be different for each map component, multiple map components are used in same page.
                    mapId: `${new Date().getTime()}_MAP_ID`,
                    gestureHandling: 'greedy'
                });
            }
            // const infoWindow = new window.google.maps.InfoWindow();
            createMarker();
            // markerListener = marker.addListener('click', () => {
            //     infoWindow.close();
            //     infoWindow.setContent(marker.title);
            //     infoWindow.open(marker.map, marker);
            // });
        };

        if (ref.current) {
            initMap(ref.current);
        }

        // return () => {
        //     window.google.maps.event.removeListener(markerListener);
        // };
    }, [center, zoom, title]);

    return <div ref={ref} style={{ height: '300px' }} />;
};

MyMapComponent.propTypes = {
    center: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    zoom: PropTypes.number,
    title: PropTypes.string,
};

// const GoogleMapComponent = () => {
const GoogleMapComponent = ({ lat = null, lng = null }) => {
    const [center, setCenter] = useState(DEFAULT_LAT_LNG);
    const [zoom] = useState(13);
    const [title, setTitle] = useState('');

    useEffect(() => {
      if (lat && lng) {
        setCenter({lat, lng});
      }
    }, [lat, lng]);

    useEffect(() => {
        const controller = new AbortController();

        const updateMapCenter = (e) => {
            const { lat, lng } = e.detail;
            setCenter({lat, lng});
            if (e.detail?.title) {
                setTitle(e.detail.title);
            }
        };

      document.addEventListener(CUSTOM_EVENTS.UPDATE_MAP_CENTER, updateMapCenter, { signal: controller.signal });

      return () => {
        controller.abort();
      };
    }, []);

    const myMapUI = (status) => {
        switch (status) {
            case Status.LOADING:
                return <Spinner />;
            case Status.FAILURE:
                return <div>Error while loading your map.</div>;
            case Status.SUCCESS:
                return <MyMapComponent center={center} zoom={zoom} title={title} />;
        }
    };

    const renderMap = () => {
        if (window.google && window.google.maps) {
            return <MyMapComponent center={center} zoom={zoom} title={title} />;
        }

        return <Wrapper apiKey={GOOGLE_CONFIG.googleMapsApiKey} render={myMapUI} />;
    };

    return (
        <GoogleWrapper>{renderMap()}</GoogleWrapper>
    );
};

GoogleMapComponent.propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
};

export default GoogleMapComponent;